import { io } from "socket.io-client";

/**
 * Socket temps réel global (notifications, événements live).
 *
 * - Développement : on passe par le proxy Vite (`proxy.conf.json` redirige
 *   `/socket.io` vers 127.0.0.1:3001) → origine courante, plus d'URL en dur.
 * - Production : le client est servi par le serveur NestJS lui-même
 *   (ServeStaticModule) → même origine que l'API.
 *
 * Reconnexion automatique activée (comportement par défaut de socket.io),
 * avec backoff exponentiel et reprise des rooms côté gateway.
 */
export const socket = io(window.location.origin, {
  withCredentials: true,
  autoConnect: true,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 15000,
  transports: ["websocket", "polling"],
});
